import { VariantProps, cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const skeletonVariants = cva(
  "rounded-md bg-muted relative overflow-hidden",
  {
    variants: {
      speed: {
        default: "animate-skeleton-pulse before:animate-shimmer",
        fast: "animate-skeleton-pulse-fast before:animate-shimmer-fast",
        slow: "animate-skeleton-pulse-slow before:animate-shimmer-slow",
      },
    },
    defaultVariants: {
      speed: "default",
    },
  }
);

interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {
  delay?: number;
}

function Skeleton({ className, speed, delay = 0, style, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        skeletonVariants({ speed }),
        "before:absolute before:inset-0 before:-translate-x-full",
        "before:bg-linear-to-r before:from-transparent before:via-white/10 before:to-transparent",
        className
      )}
      style={{
        animationDelay: `${delay}ms`,
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
